import { ServiceFetch } from '../service-fetch'

export default class PermissionModel extends ServiceFetch {
    getPermissionBy = (data) => this.authFetch({
        url: 'permission/getPermissionBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
